// Turtle (M18.1 → ties the M17 turtle helmet). PURE (ENG-1). The turtle life-cycle
// + gear rules the host drives:
//  • a turtle egg cracks over random ticks and hatches (into a baby) only at night,
//    on sand — and a mob/player stepping on it may trample it;
//  • a baby turtle grown to an adult drops one scute (→ 5 craft a turtle helmet);
//  • a worn turtle helmet grants Water Breathing while (and briefly after) the
//    wearer's head is submerged — the "world-side" bonus gear.ts leaves to us.
import { TURTLE } from '../config';

/** A worn turtle helmet grants Water Breathing while the head is underwater. */
export function turtleHelmetBreathes(headItem: string, headSubmerged: boolean): boolean {
  return headItem === 'turtle_helmet' && headSubmerged;
}

/** Duration (ticks) of the Water Breathing a turtle helmet grants — it lingers a
 *  few seconds after the head leaves the water (MC's turtle-helmet grace). */
export function turtleHelmetBreathTicks(): number {
  return TURTLE.HELMET_BREATH_TICKS;
}

/** Advance an egg's crack stage by one, clamped at the final (ready-to-hatch) crack. */
export function eggNextCrack(stage: number): number {
  return Math.min(TURTLE.EGG_CRACKS, stage + 1);
}

/** An egg hatches only once fully cracked, at night, sitting on sand. */
export function eggHatches(stage: number, isNight: boolean, onSand: boolean): boolean {
  return stage >= TURTLE.EGG_CRACKS && isNight && onSand;
}

/** A mob/player stepping on an egg may trample (break) it. */
export function eggTrampled(roll: number): boolean {
  return roll < TURTLE.TRAMPLE_CHANCE;
}

/** The item a baby turtle drops when it grows into an adult. */
export function scuteFromGrowUp(): string {
  return 'scute';
}

/** Scute needed to craft one turtle helmet. */
export function scutePerHelmet(): number {
  return TURTLE.SCUTE_PER_HELMET;
}
